export const ROLES = {
    HQ: "HQ",
    AGENT: "AGENT",
}

export const ROLE_ID = {
    HQ: 4
}

// employee_group_id